import { useSelector } from "react-redux";
import Barcode from "react-barcode";

export default function DeveloperBarcode(props) {
  const {
    value,
    className = "",
    compact = false,
    height,
    width,
    fontSize,
    displayValue,
  } = props;
  const developerMode = useSelector((state) => state.auth.developerMode);
  const barcodeValue = value == null ? "" : String(value).trim();

  if (!developerMode || !barcodeValue) {
    return null;
  }

  const resolvedHeight = height ?? (compact ? 36 : 64);
  const resolvedWidth = width ?? (compact ? 1 : 1.5);
  const resolvedFontSize = fontSize ?? (compact ? 10 : 12);
  const resolvedDisplayValue = displayValue ?? !compact;

  return (
    <div
      className={`overflow-x-auto rounded-md border border-dashed border-amber-300 bg-amber-50/60 ${
        compact ? "mt-1 p-1" : "p-2"
      } ${className}`}
      aria-label={`Developer barcode preview for ${barcodeValue}`}
    >
      {!compact ? (
        <p className="mb-1 text-[10px] font-semibold uppercase tracking-wide text-amber-700">
          Developer barcode
        </p>
      ) : null}
      <Barcode
        value={barcodeValue}
        format="CODE128"
        displayValue={resolvedDisplayValue}
        height={resolvedHeight}
        width={resolvedWidth}
        fontSize={resolvedFontSize}
        margin={0}
        background="transparent"
      />
    </div>
  );
}
